
<div mat-dialog-title>Delete Asset Category</div>
  <mat-dialog-content>
    <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
    <div class="nameHeader">{{selectedCategoryCount}} Selected categories</div>
    <div><irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'240px'"
      [gridHeight] = "'205px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)"
      [rowData] = "securityCustomCategories"></irb-inventory-grid></div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button class="btn-medium-primary" (click)="continue()">Continue</button>
  </mat-dialog-actions>